export default class FirstExchangeFlow extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onClickAddToCart = this.onClickAddToCart.bind(this);
    this.onInputChange = this.onInputChange.bind(this);

    // privates
    this._node = this;
    this._atc_btn = this._node.querySelector('.atc-btn');
    this._code_input = this._node.querySelector('input[name="discount"]');
    this._code_val = this._code_input.value.trim();
    this._pinned_atc_bar = this._node.querySelector(".pinned-atc-bar");
    this._pinned_atc_btn = this._node.querySelector('.pinned-atc-btn');
    this._id = this._atc_btn.getAttribute('data-id') ? parseInt(this._atc_btn.getAttribute('data-id'), 10) : false;
    this._rod_id = this._node.getAttribute('data-rid') ? parseInt(this._node.getAttribute('data-rid'), 10) : false;
    this._selling_plan_id = this._node.getAttribute('data-sid') ? parseInt(this._node.getAttribute('data-sid'), 10) : false;
    this._add_to_cart_error = this._node.querySelector(".atc-error");

    this._discount_name = this._node.getAttribute('data-discount').toLowerCase();
    this._node.removeAttribute('data-discount');

    this._cart_drawer = document.getElementById('cart-drawer');
    this._drawer_scroll = this._cart_drawer.querySelector('.cart-drawer-scroll');
    this._cart_btn = document.getElementById("cart-btn");

    if (this._pinned_atc_bar) {
      document.body.classList.add('--pb');
      this.pinnedBarState();
    }

    // events
    this._code_input.addEventListener('input', this.onInputChange);

    if (this._atc_btn) {
      this._atc_btn.addEventListener('click', this.onClickAddToCart);
      this._pinned_atc_btn.addEventListener('click', this.onClickAddToCart);
    }

    setTimeout(() => {
      this.checkSearchParams();
    }, 1000);
  }

  pinnedBarState() {
    let observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) {
        this._pinned_atc_bar.classList.add('--show');
      } else {
        this._pinned_atc_bar.classList.remove('--show');
      }
    });

    observer.observe(this._atc_btn);
  }

  checkSearchParams() {
    let params = new URLSearchParams(document.location.search),
        param_code = params.get("af_ex_otc");

    if (param_code && param_code.toLowerCase() === this._discount_name) {
      this._code_input.value = this._discount_name.toUpperCase();
      this.onInputChange();
    }
  }

  onInputChange() {
    this._code_val = this._code_input.value.trim().toLowerCase();

    if (this._code_val === this._discount_name) {
      this._atc_btn.classList.remove('--disabled');
      this._pinned_atc_btn.classList.remove('--disabled');
    } else {
      this._atc_btn.classList.add('--disabled');
      this._pinned_atc_btn.classList.add('--disabled');
    }
  }

  onClickAddToCart() {
    document.activeElement.blur();

    if (this._atc_btn.classList.contains('--disabled') || this._atc_btn.classList.contains('--sending')) {
      return false;
    }

    if (this._code_val.toLowerCase() === this._discount_name && this._id) {
      let items = [],
          product_data = { id: this._id, quantity: 1 };

      if (this._rod_id && this._selling_plan_id) {
        items.push({ id: this._rod_id, quantity: 1, selling_plan: this._selling_plan_id });
        items.push(product_data);
      } else {
        items.push(product_data);
      }

      this.checkCart(items, this._rod_id);
      this._atc_btn.classList.add('--sending');
      this._pinned_atc_btn.classList.add('--sending');
    }
  }

  async checkCart(items) {
    const cart_res = await fetch("/cart.js");
    const cart_json = await cart_res.json();
    let cart_items = cart_json.items;

    if (cart_items.length > 0) {
      this.emptyCart(items);
    } else {
      this.addToCart(items);
    }
  }

  emptyCart(items) {
    fetch("/cart/clear.js", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (!response.ok) {
        console.log(response);
      } else {
        return response.json();
      }
    })
    .then((response) => {
      if (response) {
        this.addToCart(items);
      }
    })
  }

  async addToCart(items) {
    fetch("/cart/add.js", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({items})
    })
    .then((response) => {
      if (!response.ok) {
        console.log(response);
        let error = "An error occured! Please try again later.";
        this.updateProductError(error);
      } else {
        return response.json();
      }
    })
    .then((response) => {
      if (response) {
        this.updateCartDrawer();
      }
    })
  }

  async updateCartDrawer() {
    const cart_res = await fetch("/cart.js");
    const cart = await cart_res.json();
    this.updateCartCount(cart.item_count);

    const drawer_res = await fetch("/?section_id=cart-drawer");
    const text = await drawer_res.text();
    const html = document.createElement("div");
    html.innerHTML = text;
    const template = html.querySelector(".cart-drawer-box").innerHTML;

    document.querySelector(".cart-drawer-box").innerHTML = template;
    this.updateProductError();
    this.openCartDrawer();
  }

  updateCartCount(item_count) {
    let count = this._cart_btn.querySelector('.count');

    if (item_count > 0) {
      this._cart_btn.classList.remove('--empty');
    } else {
      this._cart_btn.classList.add('--empty');
    }

    count.innerText = item_count;
  }

  updateProductError(error) {
    this._atc_btn.classList.remove('--sending');
    this._pinned_atc_btn.classList.remove('--sending');

    if (error) {
      this._add_to_cart_error.innerHTML = `<p>${error}</p>`;
      this._add_to_cart_error.style.display = "block";

      let event_horizon = window.pageYOffset,
          destination = this._node.getBoundingClientRect().top + event_horizon - 96;

      if (Math.round(destination) !== Math.round(event_horizon)) {
        window.scroll({
          top: destination,
          left: 0,
          behavior: 'smooth'
        });
      }
    } else {
      this._add_to_cart_error.innerHTML = "";
      this._add_to_cart_error.style.display = "none";
    }
  }

  openCartDrawer() {
    this._cart_drawer.classList.add('--open-drawer');
    this._drawer_scroll.scrollTop = 0;
    document.body.style.overflow = 'hidden';
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
    this._code_input.removeEventListener('input', this.onInputChange);

    if (this._atc_btn) {
      this._atc_btn.removeEventListener('click', this.onClickAddToCart);
      this._pinned_atc_btn.removeEventListener('click', this.onClickAddToCart);
    }
  }
}
